import React, { Suspense, useRef } from 'react'
import { useStateValue } from '../../utils/provider/StateProvider';
import { useFrame } from '@react-three/fiber';
import * as THREE from "three";
import universeRawData from "../data/universe.json";
import { Effects, Html } from '@react-three/drei';
import HelixNebula from './HelixNebula';


function Nucleus({ size }) {
    const nucleusRef = useRef();
    const color = new THREE.Color();
    color.setHSL(Math.random(), 0.7, Math.random() * 0.2 + 0.05);
  
    return (
      <mesh ref={nucleusRef} position={[0, 0, 0]} scale={[size, size, size]}>
        <sphereGeometry attach="geometry" args={[0.5, 32, 32, 0, 6.4, 0, 6.3]} />
        <meshBasicMaterial attach="material" color={"#fff"} />
      </mesh>
    );
  }



function NebulaSystems({galaxy, name, selectedGalaxy, onChangeGalaxyView}) {
      
  // arguments:
  const galaxyData = galaxy;
  const galaxyName = name;
  const galaxyTilt = (parseInt(galaxy.data.right_ascension.split(":")) * Math.PI) / 180; // Convert hours to radians


  const [{showInfo}, dispatch] = useStateValue();

  const dof = useRef();
  const galaxySystemMesh = useRef();

  const meshRef = useRef(null);

  // This function creates position of galaxy with ref to milkyway:
  const createPositions = (data) => {
    const ra = data.right_ascension.split(":");
    const decDegree = data.declination.split(":");
    const distance = data.distance;

    const raDegrees =
      parseInt(ra[0]) + parseInt(ra[1]) / 60 + parseInt(ra[2]) / 3600;

    const decDegrees =
      parseInt(decDegree[0]) +
      parseInt(decDegree[1]) / 60 +
      parseInt(decDegree[2]) / 3600;

    const raRadians = (raDegrees * Math.PI) / 180;
    const decRadians = (decDegrees * Math.PI) / 180;
    const x = distance * Math.cos(decRadians) * Math.cos(raRadians);
    const y = distance * Math.cos(decRadians) * Math.sin(raRadians);
    const z = distance * Math.sin(decRadians);

    return [x, y, z];
  };

  // Galaxy Position:
  const galaxyCoord =
    galaxyName === selectedGalaxy ? [0, 0, 0] : createPositions(galaxyData.data);


    // useFrame(() => {
    //   if (typeof galaxySystemMesh.current !== "undefined") {
    //     galaxySystemMesh.current.rotation.y += 0.001;

    //     // Apply tilt
    //     if(galaxyData.data.style.length === 1){
    //       if (galaxyName !== selectedGalaxy) {
    //         galaxySystemMesh.current.rotation.x = galaxyTilt +20;
    //         galaxySystemMesh.current.rotation.z = galaxyTilt + -10;
          
    //       } 
    //     }else{
    //       if(galaxyData.data.style[1].hasOwnProperty("angle")){
    //         galaxySystemMesh.current.rotation.z = galaxyData.data.style[1].angle
    //         galaxySystemMesh.current.rotation.y = 0
    //       }
    //     }
    //   }
    // });


  const onGalaxyClicked = () => {
    // Set the galaxy view:
    onChangeGalaxyView(name, galaxyCoord) 

    // View Galaxy modal:
    dispatch({
      type: "SHOW_INFO",
      showInfo: true
    }) 
  }


  const system = universeRawData[selectedGalaxy].systems

  let planetrySystems = {}
  Object.keys(system).map(i => {
    if(system[i].hasOwnProperty("data")){
      const position = createPositions(system[i].data)
      planetrySystems[i] = {
        "name": system[i].data.name,
        "position": position
      }
    }
  })


  return (
    <mesh>
      <group>
        <mesh ref={meshRef} position={galaxyCoord}>
          {galaxyName === selectedGalaxy &&
            galaxyData.data.style.map(i => (
              <mesh ref={galaxySystemMesh} position={i && i.position}>
                <Suspense fallback={null}>
                  {/* <Galaxy dof={dof} galaxy={galaxyData} name={galaxyName} style={i}/> */}
                  <HelixNebula dof={dof} galaxy={galaxyData} name={galaxyName} style={i}/>
                  <Nucleus size={0.125} />
                </Suspense>
                <Effects ref={dof} />
              </mesh>
            )
            )
          }

          <Html>
            <div className="planetDisplayName" onClick={() => onGalaxyClicked()}>
              <p id="planetNameClicked" style={{ fontSize: "12px", color: "white", width: "200px", cursor:'pointer'}}>{universeRawData[name].data.name}</p>
            </div>
          </Html>
            
        </mesh>
      </group>
    </mesh>
  );
}

export default NebulaSystems

